﻿/**
 * portal-admin-settingkeys.directive
 * @namespace portal
 */

(function () {
	'use strict';

	/** get the angular module and add directive */
	angular.module('nha.portal').directive('portalAdminSettings', portalAdminSettingsDirective);

	/** implementation */
	function portalAdminSettingsDirective() {
		/** return directive */
		return {
			restrict: 'E',
			templateUrl: 'app/portal-admin/portal-admin-settings/portal-admin-settings.directive.html',
			controller: 'portal-admin-settings.controller',
			controllerAs: 'portalAdminSettingsCtrl',
			scope: {}
		};
	}
})();